export default __webpack_public_path__ + "static/media/4c.d3ca6a94.png";